<template>
  <b-modal
      :ref="modalRef"
      no-close-on-backdrop
      centered
      :header-bg-variant="headerBgVariant"
      header-text-variant="white"
      body-bg-variant="white"
      body-text-variant="dark"
      footer-bg-variant="white"
      footer-text-variant="dark"
      :hide-footer="hideFooter"
      :size="modalSize"
      :id="id"
      :title-html="titleHtml"
      class="font-size-base"
      @hidden="resetModal"
      scrollable
  >
    <b-overlay
        id="overlay-background"
        :show="isBusy"
        variant="white"
        spinner-variant="success"
        :opacity="0.85"
        blur="2px"
        rounded="sm">
      <slot name="modal-content">
      </slot>
    </b-overlay>
    <b-row align-v="center">
      <b-col v-if="withSideIcon" class="col-1 p-0 pt-1 text-center">
        <b-icon v-if="headerBgVariant === 'info'" icon="exclamation-circle-fill" class="h1 mb-2 pr-1"
                :variant="headerBgVariant"></b-icon>
        <b-icon v-if="headerBgVariant === 'danger'" icon="exclamation-triangle" class="h1 mb-2 pr-1"
                :variant="headerBgVariant"></b-icon>
      </b-col>
      <b-col align-content class="pl-2 p-0 ">
        <slot name="modal-form">
        </slot>
      </b-col>
    </b-row>
    <template #modal-header="{}">
      <span class="text-white font-weight-bolder" v-html="titleHtml"></span>
      <!-- Emulate built in modal header close button action -->
      <button type="button" aria-label="Close" class="close text-white" @click="onModalReturn">×</button>
    </template>

    <template v-if="!hideFooter" #modal-footer="{ }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-row style="justify-content: flex-start!important;">
        <b-button v-if="!withoutReturn" d="modal-delete" size="sm" :variant="modalReturnVariant" class="mr-2"
                  @click="onModalReturn">
          <p class="h8 mb-0">
            <b-icon-arrow-bar-left class="pr-1"></b-icon-arrow-bar-left>
            {{ buttonReturnCaption }}
          </p>
        </b-button>
        <b-button v-if="!withoutSubmit" d="modal-submit" size="sm" class="mr-2" :variant="modalSubmitVariant"
                  :disabled="isSelected"
                  @click="onModalSelected">
          <p class="h8 mb-0">
            <b-icon-arrow-bar-right class="pr-1"></b-icon-arrow-bar-right>
            {{ buttonSelectCaption }}
          </p>
        </b-button>
      </b-row>
    </template>
    <template v-if="!withoutButtons">
      <template v-if="hideFooter">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-row :class="defaultClass">
          <b-button v-if="!withoutReturn" d="modal-delete" size="sm" :variant="modalReturnVariant" class="mr-2"
                    @click="onModalReturn">
            <p class="h8 mb-0">
              <b-icon-arrow-bar-left class="pr-1"></b-icon-arrow-bar-left>
              {{ buttonReturnCaption }}
            </p>
          </b-button>
          <b-button v-if="!withoutSubmit" d="modal-submit" size="sm" class="mr-2" :variant="modalSubmitVariant"
                    :disabled="isSelected"
                    @click="onModalSelected">
            <p class="h8 mb-0">
              <b-icon-arrow-bar-right class="pr-1"></b-icon-arrow-bar-right>
              {{ buttonSelectCaption }}
            </p>
          </b-button>
        </b-row>
      </template>
    </template>

  </b-modal>
</template>

<script>
import {getCaption} from "@/util/Helpers";
import {mapState} from "vuex";

export default {
  name: "BaseBModal",
  props: {
    withoutButtons: {
      default: () => false,
      require: false,
      type: Boolean
    },
    withoutReturn: {
      default: () => false,
      require: false,
      type: Boolean
    },
    withoutSubmit: {
      default: () => false,
      require: false,
      type: Boolean
    },
    hideFooter: {
      default: () => false,
      require: false,
      type: Boolean
    },
    withSideIcon: {
      default: () => false,
      require: false,
      type: Boolean
    },
    defaultClass: {
      default: () => "modal-footer2 mt-4 mb-1 p-0 justify-content-center align-items-center",
      require: false,
      type: String
    },
    modalRef: {
      default: () => "modalRef",
      require: false,
      type: String
    },
    id: {
      default: () => "custom-modal-id",
      require: false,
      type: String
    },
    titleHtml: {
      default: () => "Επεξεργασία",
      require: false,
      type: String
    },
    isSelected: {
      default: () => true,
      require: false,
      type: Boolean
    },
    modalSize: {
      default: () => 'lg',
      require: false,
      type: String
    },
    buttonSelectCaption: {
      default: () => getCaption('BUTTON_SELECT'),
      require: false,
      type: String
    },
    buttonReturnCaption: {
      default: () => getCaption('LABEL_BACK'),
      require: false,
      type: String
    },
    modalReturnVariant: {
      default: () => 'danger',
      require: false,
      type: String
    },
    modalSubmitVariant: {
      default: () => 'success',
      require: false,
      type: String
    },
    headerBgVariant: {
      default: () => "info",
      require: false,
      type: String
    }
  },
  computed: {
    ...mapState(
        {
          isBusy: state => state.sub1.isBusy
        },
    ),
  },
  methods: {
    onModalReturn() {
      this.$emit("handle-modal-return");
    },
    onModalSelected() {
      this.$emit("handle-modal-selected");
    },
    resetModal() {
      this.$emit("handle-modal-reset");
    }
  }
}
</script>

<style>
.modal-footer2 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0.80rem;
  border-top: 0 solid rgba(0, 0, 0, 0.1);
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}
</style>